// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleRegistrationTokenManager = {
  id: "registration-token-manager",
  mrn: "//iam.api.mondoo.app/roles/registration-token-manager",
  title: "Registration Token Manager",
  allowedActions,
} as const;

export type RoleRegistrationTokenManager = typeof roleRegistrationTokenManager;
